import {
  publicHttpClient,
  type AxiosRequestConfig,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import type { MealPlanResponse } from './use-get-meal-plan';

export interface UpdateMealPlanRequestBody {
  date: string;
  slot: string;
  item_name: string;
  overall_dish_tag: string;
  image_thumb_urls: string;
  category_solo_meal: string[];
  estimated_price: number;
}

export const updateMealPlanFn = async (
  token: string,
  body: UpdateMealPlanRequestBody,
  config: AxiosRequestConfig = {}
): Promise<MealPlanResponse> => {
  const response = await publicHttpClient.post<MealPlanResponse>(
    apiRoutes.ahafood.store.update_meal_plan,
    body,
    {
      headers: { Authorization: `Bearer ${token}` },
      ...config,
    }
  );

  return response?.data;
};

export const useUpdateMealPlan = (
  token: string,
  opts?: UseMutationOptions<
    MealPlanResponse,
    DefaultQueryError,
    UpdateMealPlanRequestBody
  >
) =>
  useMutation<MealPlanResponse, DefaultQueryError, UpdateMealPlanRequestBody>({
    mutationFn: (variables) => updateMealPlanFn(token, variables),
    ...opts,
  });
